import React from "react";
import { Link } from "react-router-dom";

const PageHero = ({ crumbs = [], title, lead }) => {
  return (
    <section className="page-hero" data-testid="page-hero">
      <div className="container-rb">
        {crumbs.length > 0 && (
          <div className="page-hero__crumbs">
            {crumbs.map((c, i) => (
              <span key={i}>
                {c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}
                {i < crumbs.length - 1 && " / "}
              </span>
            ))}
          </div>
        )}
        <h1 data-testid="page-hero-title">{title}</h1>
        {lead && <p className="page-hero__lead">{lead}</p>}
      </div>
    </section>
  );
};

export default PageHero;
